import React from "react";
import { PORTAL, THEME } from "../lib";
import Intro from "./Intro";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core/styles";
import Portals from "./Portals";
import Portal from "./Portal";

function App() {
  return (
    <>
      <CssBaseline />
      <ThemeProvider theme={THEME}>
        <Intro />
        <Portals>
          {PORTAL.map(({ title, subheader, icon, href, image, color }) => (
            <Portal
              key={`PORTAL_${title}`}
              href={href}
              title={title}
              icon={icon}
              image={image}
              subheader={subheader}
              color={color}
            />
          ))}
        </Portals>
      </ThemeProvider>
    </>
  );
}

export default App;
